module.exports = __webpack_public_path__ + "static/undraw_contact_us_15o2-5c4bdfcf05c211f3d79244f0fed97865.svg";